import { costEstimate, type Pricing, type QuantitiesResult } from "@tasduvar/engine";

/** Sayı: binlik ayraçsız, ondalık virgül (Türkçe Excel CSV içe aktarımı) */
const num = (v: number): string => String(Math.round(v * 1000) / 1000).replace(".", ",");

const esc = (v: string | number): string => { const s = typeof v === "number" ? num(v) : v; return /[";\n]/.test(s) ? `"${s.replace(/"/g, "\"\"")}"` : s; };
const row = (cells: (string | number)[]): string => cells.map(esc).join(";");

/** Metraj CSV (noktalı virgül ayraç, UTF-8 BOM — Türkçe Excel'de doğrudan açılır). Birden çok duvar alt alta; sonda keşif özeti. */
export function buildQuantitiesCsv(walls: { name: string; q: QuantitiesResult }[], pricing: Pricing): string {
  const lines: string[] = [];
  lines.push(row(["Duvar", "İmalat", "Birim", "1 m için", "Toplam", "Hesap"]));
  for (const { name, q } of walls) {
    for (const l of q.lines) lines.push(row([name, l.label.trim(), l.unit, l.perMetre, l.total, l.formula]));
    if (q.rebar) {
      lines.push("");
      lines.push(row([name, "Donatı metrajı", "φ", "Adet / m", "Boy (m)", "kg / m", "Toplam (kg)"]));
      for (const b of q.rebar.byPosition) lines.push(row([name, b.label, b.dia, b.countPerMetre, b.length, b.kgPerMetre, b.total]));
      for (const d of q.rebar.byDiameter) lines.push(row([name, `Toplam φ${d.dia}`, d.dia, "", "", d.kgPerMetre, d.total]));
      lines.push(row([name, "Toplam donatı", "", "", "", q.rebar.kgPerMetre, q.rebar.total]));
    }
    lines.push("");
  }
  const c = costEstimate(walls.map((w) => w.q), pricing);
  lines.push(row(["Keşif özeti", "Poz no", "Tanım", "Birim", "Miktar", `Birim fiyat (${c.currency})`, `Tutar (${c.currency})`]));
  for (const r of c.rows) lines.push(row(["", r.code, r.label, r.unit, r.quantity, r.unitPrice || "", r.amount ?? ""]));
  lines.push(row(["", "", "Toplam (KDV hariç)", "", "", "", c.priced ? c.total : ""]));
  if (c.note) lines.push(row(["NOT", c.note]));
  return "﻿" + lines.join("\r\n");
}
